import { navLinks, siteName } from "@/mocks/homeData";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg">
                <i className="ri-sparkling-2-fill" />
              </span>
              <span className="font-heading text-xl text-background-50">{siteName}</span>
            </div>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-100/70">
              本站为妖精动漫的访问信息指引页，汇总官网入口、APP 下载与最新地址的获取方式。所有内容仅用于帮助用户更高效地找到正确的访问路径，不提供影片播放或存储服务。
            </p>
            <a
              href="#address"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-links-line" />
              回到最新地址说明
            </a>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-background-50 text-base">页面导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-100/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-background-50 text-base">使用提示</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-100/70">
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-accent-300" />
                地址以官方发布为准
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-accent-300" />
                建议保存多个备用入口
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-accent-300" />
                勿在陌生页面输入账号
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-accent-300" />
                定期回访查看更新
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-100/60">
          <p>© {new Date().getFullYear()} {siteName} 入口指引 · 内容仅供访问参考</p>
          <p>请遵守当地法律法规，合理使用网络服务</p>
        </div>
      </div>
    </footer>
  );
}